import { ColorHues } from "@chakra-ui/react";

/**
 * Generated via https://lyft-colorbox.herokuapp.com/
 */
export const PrimaryColors: ColorHues = {
    50: "#FF9597",
    100: "#FD6568",
    200: "#F9383B",
    300: "#F21115",
    400: "#E90004",
    500: "#DD0004",
    600: "#CD0003",
    700: "#B80003",
    800: "#A00003",
    900: "#870002",
};

export const PrimaryDarkColors: ColorHues = {
    50: "#F5F5F5",
    100: "#F0EEEE",
    200: "#ECE7E7",
    300: "#D5CCCD",
    400: "#706868",
    500: "#807777",
    600: "#50494A",
    700: "#2A2727",
    800: "#131212",
    900: "#0A0909",
};
